import { Link } from 'react-router-dom';

/**
 * Persistent footer per PRD §3.2. Renders on every page.
 * Investors link lives here since investor inbound is high-intent + low-volume.
 */
export function Footer(): JSX.Element {
  return (
    <footer className="border-t border-sovereign-line bg-sovereign-850 px-6 py-3 text-[11px] text-ink-mute md:px-10">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-x-6 gap-y-2">
        <div className="flex items-center gap-2">
          <span aria-hidden>©</span>
          <span>{new Date().getFullYear()} DI Deck</span>
          <span className="text-ink-dim">·</span>
          <span>Sovereign Decision Intelligence</span>
        </div>
        <nav aria-label="Legal + contact" className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <FooterLink to="mailto:sales@dideck.com" external>Contact sales</FooterLink>
          <FooterLink to="/investors">Investors</FooterLink>
          <FooterLink to="/legal/privacy">Privacy</FooterLink>
          <FooterLink to="/legal/terms">Terms</FooterLink>
          <FooterLink to="/legal/dpa">DPA</FooterLink>
        </nav>
      </div>
    </footer>
  );
}

function FooterLink({
  to, children, external = false,
}: {
  to: string;
  children: string;
  external?: boolean;
}): JSX.Element {
  if (external) {
    return (
      <a href={to} className="hover:text-brand-purple hover:underline">
        {children}
      </a>
    );
  }
  return (
    <Link to={to} className="hover:text-brand-purple hover:underline">
      {children}
    </Link>
  );
}
